module.exports = {
	url: '/peaks-picks',
	template: require('raw!templates/peaks-picks/peaks-picks-view.html'),
	controller: peaksPicksController,
	controllerAs: 'peaksPicksCtrl',
};

function peaksPicksController($scope, $state, store, $window, contentful, $http) {
	var vm = this;
  $window.scrollTo(0, 0);

	$scope.tab = 1;

 	$scope.setTab = function(newTab){
	 $scope.tab = newTab;
 };

 	$scope.isSet = function(tabNum){
	 return $scope.tab === tabNum;
 };
 contentful.entries('content_type=longPage&sys.id=6GD94B8cdqWiwM2O0GCa48').then(function(res) {
	//  console.log('picks page contentful data',res);
	 $scope.picks = res.data.items[0];
	 var seoData = res.data.items[0];
	 if (seoData.fields.seoPageTitle) {
		 document.title = seoData.fields.seoPageTitle;
	 }
	 if (seoData.fields.seoPageDescription) {
		 var meta = document.getElementsByTagName("meta");
		 for (var i = 0; i < meta.length; i++) {
			 if (meta[i].name.toLowerCase() === "description") {
				 meta[i].content = seoData.fields.seoPageDescription;
			 }
		 }
	 }
 });
}



// WEBPACK FOOTER //
// ./components/templates/peaks-picks/peaks-picks-controller.js